import styled from 'styled-components'

const Bar = styled.div`
  background: ${(props) => props.theme.palette.primary.main};
  padding: ${(props) => `${props.theme.spacing[8]} 0`};
`

export default Bar
